module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-flyer.4f5c7876.jpg";